export enum CANCEL_REASONS {
  OUT_OF_STOCK = 'out_of_stock',
  SELLER_CANCEL = 'seller_cancel',
  BUYER_REQUEST = 'buyer_request'
}

export const CANCELLATION_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected'
} as const;

export type CancellationStatus = typeof CANCELLATION_STATUS[keyof typeof CANCELLATION_STATUS];

export const ORDER_STATUS = {
  AWAITING_PAYMENT: 'awaiting_payment',
  PENDING: 'pending',
  PROCESSING: 'processing',
  PREPARATION: 'preparation',
  AWAITING_STOCK: 'awaitingStock',
  AWAITING_PICKUP: 'awaitingPickup',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
  RETURNED: 'returned'
} as const;

export type OrderStatus = typeof ORDER_STATUS[keyof typeof ORDER_STATUS];

export type OrderSource = 'woocommerce' | 'online' | 'private' | 'manual';
export type OrderType = 'standard' | 'subscription' | 'wholesale' | 'private';

export interface Order {
  id: string;
  orderNumber?: string;
  status: OrderStatus;
  hasCancellationRequest?: boolean;
}

export interface CancellationRequest {
  orderId: string;
  orderNumber?: string;
  orderData: any;
  requestDate: string;
  requestedBy: string;
  reason: CANCEL_REASONS;
  additionalNotes: string;
  status: CancellationStatus;
  companyId: string;
  source: OrderSource;
  orderType: OrderType;
  reviewedBy?: string;
  reviewDate?: string;
  reviewNotes?: string;
}
